// extracted by mini-css-extract-plugin
export var label = "_rz-0";
export var link = "_rz-1";